import React, { useState, useEffect, useContext } from 'react';
import '../../css/nav.css';
import Status from './Status';
import Levels from './Levels';
import Select from './Select';
import { functionContext } from '../../App';

function Nav(props) {

  let { number,
  allLevelStatus,
  selectedLevel,
  loading
 } = props;

 const { resetAllLevels } = useContext(functionContext);

// console.log(allLevelStatus);

// countCompletedLevels()

const [stateStatus, setstateStatus] = useState(0);

function countCompletedLevels() {
  if (!Array.isArray(allLevelStatus) || allLevelStatus.length === 0) {
    setstateStatus(0);
    return;
  }

  let completedLevels = 0;
  let completedList = allLevelStatus.filter(level => (level.is_completed === true))
  completedLevels = completedList.length;

  let statusBarNumber = (Math.ceil((completedLevels/187) * 100));
  // console.log(statusBarNumber)
  setstateStatus(statusBarNumber)
}

useEffect(() => {
  countCompletedLevels()
}, [allLevelStatus])

// console.log(stateStatus)

// let completed = statusBarNumber.toFixed(2);

   //progress bar test data
   const testData = [
    { bgcolor: "#e1aa7d", completed: stateStatus },
  ];
 
  const levelsLoading = loading || !Array.isArray(allLevelStatus) || allLevelStatus.length === 0 || !number?.count;

  return (
    <>
      <div id="navbar">
        
      {testData.map((item, idx) => (
        <Status key={idx} bgcolor={item.bgcolor} completed={item.completed} onReset={resetAllLevels} />
      ))}
          {!levelsLoading && (
            <Levels allLevelStatus={allLevelStatus} {...allLevelStatus} selectedLevel={selectedLevel} number={number} />
          )}
          <Select/>
        
      </div>
    </>
  )
}

export default Nav;
